import { render, staticRenderFns } from "./img.vue?vue&type=template&id=7f33fc52&scoped=true"
import script from "./img.vue?vue&type=script&lang=ts"
export * from "./img.vue?vue&type=script&lang=ts"
import style0 from "./img.vue?vue&type=style&index=0&id=7f33fc52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f33fc52",
  null
  
)

export default component.exports